var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Package'),_c('Blog'),_c('FAQ'),_c('Testimonial'),_c('Screenshots'),_c('Team'),_c('Copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }